import { render } from "./FreeWrite.vue?vue&type=template&id=6d80d344&scoped=true"
import script from "./FreeWrite.vue?vue&type=script&lang=js"
export * from "./FreeWrite.vue?vue&type=script&lang=js"

import "./FreeWrite.vue?vue&type=style&index=0&id=6d80d344&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d80d344"]])

export default __exports__